"use client"

import { useTheme } from "next-themes"
import { Icon } from "@/shared/ui/icon"

const ThemeToggle: React.FC = () => {
  const { resolvedTheme, setTheme } = useTheme()

  const handleToggle = () => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark")
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label="Переключить тему"
      title="Переключить тему"
      className="inline-flex items-center justify-center cursor-pointer rounded-md p-2 text-gray-700 hover:bg-gray-100 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 dark:text-gray-300 dark:hover:bg-white/5"
    >
      <span className="sr-only">Переключить тему</span>
      <Icon name="moon-linear" aria-hidden="true" className="size-5 dark:hidden" />
      <Icon name="sun-linear" aria-hidden="true" className="hidden size-5 dark:block" />
    </button>
  )
}

export default ThemeToggle
